<template>
  <KioskAuthLayout
    :show-next-button="false"
    :is-new="true"
    show-back-button
    title="Save Past Orders"
    @back="handleBack">
    <ul :class="$style.advantagesList">
      <li :class="$style.advantagesListItem">
        <div :class="$style.checkmark">
          <svg v-svg
               :class="$style.checkmarkWhite"
               symbol="checkmark-icon" />
        </div>
        <p>
          Register a phone number at our kiosk, online, or through our mobile
          app.
        </p>
      </li>

      <li :class="$style.advantagesListItem">
        <div :class="$style.checkmark">
          <svg v-svg
               :class="$style.checkmarkWhite"
               symbol="checkmark-icon" />
        </div>
        <p>Use this phone number when you order.</p>
      </li>

      <li :class="$style.advantagesListItem">
        <div :class="$style.checkmark">
          <svg v-svg
               :class="$style.checkmarkWhite"
               symbol="checkmark-icon" />
        </div>
        <p>Re-order up to 5 of your past orders, quickly and easily!</p>
      </li>
    </ul>
    <div :class="$style.advBlock">
      <h2>Order Online!</h2>
      <p>Burger Boss mobile apps now available</p>
      <div :class="$style.appsButtons">
        <a href="#">
          <img
            src="@/assets/img/app_store.png"
            alt="Download on the AppStore"
          >
        </a>
        <a href="#">
          <img src="@/assets/img/google_play.png"
               alt="Get it on Google Play" >
        </a>
      </div>
    </div>
  </KioskAuthLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskAuthLayout from '@/layouts/KioskAuthLayout';

/* Provide OrdersInfo screen */
@Component({
  components: {
    KioskAuthLayout,
  },
})
export default class KioskOrdersInfo extends Vue {
  handleBack() {
    this.$router.go(-1);
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.advantagesList {
  list-style: none;
  margin: 96px 124px 112px;
  padding-left: 0;
}

.advantagesListItem {
  display: flex;
  margin-bottom: 42px;
  p {
    font-size: 34px;
    line-height: 38px;
    letter-spacing: -0.48px;
  }
}

.checkmark {
  width: 38px;
  height: 38px;
  background-color: $green-color;
  border-radius: 50%;
  margin-right: 22px;
  .checkmarkWhite {
    width: 38px;
    height: 38px;
    fill: $white;
  }
}

.advBlock {
  height: 464px;
  padding: 94px 370px 92px 64px;
  background-color: $light-choice-bg;
  background-image: url('/assets/img/image_iPhone.jpg');
  background-position: right bottom;
  h2 {
    font-size: 44px;
    line-height: 53px;
    font-weight: 300;
    margin-bottom: 21px;
  }
  p {
    font-size: 34px;
    line-height: 48px;
  }
}

.appsButtons {
  margin-top: 62px;
  a {
    display: inline-block;
    width: 194px;
    height: 55px;
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/PastOrdersInfo.vue